import React, {PureComponent} from "react";
import {BenefitEntity, ProgressionLevelEntity} from "../data/entities/ProgressionLevelEntity";
import giftIcon from "../resources/icons/icon-gift.svg";
import benefitIcon from "../resources/icons/icon-benefits.svg";
import boosterIcon from "../resources/icons/icon-boosters.svg";
import {FormattedMessage, FormattedPlural} from "react-intl";
import classNames from 'classnames';
import {UserProgressionInfoEntity} from "../data/entities/UserProgressionInfoEntity";

const separatorLine = require("../resources/img/separator-line.png");

interface Props {
    progressionLevel: ProgressionLevelEntity;
    userProgressionInfo: UserProgressionInfoEntity;
}

export default class ProgressionLevelItem extends PureComponent<Props> {

    getProgressionLevelIcon(benefit: BenefitEntity) {
        let icon = null;
        switch (benefit.typeId) {
            case 1:
                icon = giftIcon;
                break;
            case 2:
                icon = benefitIcon;
                break;
            case 3:
                icon = boosterIcon;
                break;
        }

        return (icon === null) ? null : <span className={"benefitIcon"} ><img src={icon} alt=""/></span>;
    }

    getProgressionLevelTextLabel(benefit: BenefitEntity) {
        let benefitType = "";
        let suffix = <></>;

        switch (benefit.typeId) {
            case 1:
                benefitType = "reward";
                suffix = <> <span>/</span><span className={"suffix"}><FormattedMessage id="general.date.month" /></span></>;
                break;
            case 2:
                benefitType = "benefit";
                break;
            case 3:
                benefitType = "booster";
                break;
        }

        return <>
                <FormattedPlural
                    one={<FormattedMessage id={`progression.benefit.singular.${benefitType}`} tagName="span" />}
                    other={<FormattedMessage id={`progression.benefit.plural.${benefitType}`} tagName="span" />}
                    value={parseInt(benefit.value)}
                />
                {suffix}
                </>
    }

    render(): JSX.Element {
        const {progressionLevel, userProgressionInfo} = this.props;
        const active: boolean = (progressionLevel.id === (userProgressionInfo.currentProgressionLevel?userProgressionInfo.currentProgressionLevel.id:-1));

        let className = classNames({
            "col": true,
            "uplayBenefit": true,
            "active": active
        });

        return (
            <div className={className} id={active ? "active-progression-level" : undefined}>
                <div className="uplayBenefitContentsOuterWrap">
                    <div className="uplayBenefitContents">
                        <div className="topShape"></div>
                        <div className="progressionLevelDetails">
                            <img src={progressionLevel.image} className="progressionLevelLogo" alt="" />
                            <div>
                                <p className="name">
                                    {progressionLevel.name}
                                </p>
                                <p className="ruleSubscriptionMonths">
                                    {
                                        progressionLevel.monthsRequiredInfo !== null &&
                                            <>{progressionLevel.monthsRequiredInfo}</>
                                    }
                                    {
                                        progressionLevel.monthsRequiredInfo === null &&
                                        <FormattedPlural
                                            zero={<FormattedMessage id="progression.level.subscription.first_month"/>}
                                            one={<FormattedMessage id="progression.level.subscription.first_month"/>}
                                            other={<FormattedMessage id="progression.level.subscription.starting_with_months"
                                                                     values={{months: progressionLevel.ruleSubscriptionMonths}}/>}
                                            value={progressionLevel.ruleSubscriptionMonths}
                                        />
                                    }
                                </p>
                                <div className="separatorLine">
                                    <img src={separatorLine} alt="" />
                                </div>
                                <div className="benefitsList">
                                    {progressionLevel.benefits.map((benefit, index) => {
                                        return (
                                            <div className="benefit" key={`benefit-${progressionLevel.id}-${index}`}>
                                                {this.getProgressionLevelIcon(benefit)}
                                                <span className="value">{benefit.value}</span> {this.getProgressionLevelTextLabel(benefit)}
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}